import React from "react";
import { Alert, Link } from "@mui/material";

const DecommissionBanner = () => {
  return (
    <Alert
      severity="warning"
      variant="filled"
      sx={{
        borderRadius: 0,
        py: 0.25,
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 600,
        fontSize: '0.78rem',
        '& .MuiAlert-icon': { py: 0, fontSize: '1.1rem' },
        '& .MuiAlert-message': { py: 0.25, textAlign: 'center' },
      }}
    >
      This SDL website will be decommissioned in the coming days. Please transition to the Atmos version of SDL{' '}
      <Link
        href="https://sdl-webapp.apps.gmna.krypton.atmos.gm.com/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: 'inherit', fontWeight: 700, textDecorationColor: 'inherit' }}
      >
        URL
      </Link>
      &nbsp;and update your bookmarks accordingly.
    </Alert>
  );
};

export default DecommissionBanner;
